<template>
  <div v-if="flag">

    <div class="row">
      <div class="col-lg-4 data-list-container">
        <div class="con-vs-card min-h-210">
          <div class="vs-card&#45;&#45;content">
            <div class="flex items-center">
              <div class="p-4 flex-1">

                <div class="center">
                  <div style="background: var(--secondary-color);" class="cricle">
                    <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px"
                         fill="#fff">
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path
                          d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                    </svg>
                  </div>
                  <h6 class="card-title minh40">جمع مبلغ کل خرید</h6>
                  <h5>{{ data.sum |price }}</h5>
                  <h5>تومان</h5>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 data-list-container">
        <div class="con-vs-card min-h-210">
          <div class="vs-card&#45;&#45;content">
            <div class="flex items-center">
              <div class="p-4 flex-1">
                <div class="center">
                  <div style="background: var(--primary-color)" class="cricle">
                    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="30px"
                         viewBox="0 0 24 24" width="30px" fill="#fff">
                      <g>
                        <path
                            d="M18,6h-2c0-2.21-1.79-4-4-4S8,3.79,8,6H6C4.9,6,4,6.9,4,8v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8C20,6.9,19.1,6,18,6z M12,4c1.1,0,2,0.9,2,2h-4C10,4.9,10.9,4,12,4z M18,20H6V8h2v2c0,0.55,0.45,1,1,1s1-0.45,1-1V8h4v2c0,0.55,0.45,1,1,1s1-0.45,1-1V8 h2V20z"/>
                      </g>
                    </svg>
                  </div>
                  <h6 class="card-title minh40">جمع کل تعداد خرید</h6>
                  <h5>{{ data.total_orders }}</h5>
                  <h5>عدد</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 data-list-container">
        <div class="con-vs-card min-h-210">
          <div class="vs-card&#45;&#45;content">
            <div class="flex items-center">
              <div class="p-4 flex-1">
                <div class="center">
                  <div style="background: var(--secondary-color)" class="cricle">
                    <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px"
                         fill="#fff">
                      <path d="M0 0h24v24H0V0z" fill="none"/>
                      <path
                          d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                    </svg>
                  </div>
                  <h6 class="card-title minh40">جمع مبلغ خرید ماه گذشته</h6>
                  <h5>{{ data.sum_last_30_days |price }}</h5>
                  <h5>تومان</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row same-height">

      <div class="col-lg-4 data-list-container">
        <div class="con-vs-card  minh251" @click="walletModel = true">
          <div class="vs-card content">
            <div class="flex items-center minh251">
              <div class="p-4 flex-1">

                <div class="center">
                  <div style="background: var(--primary-color);" class="cricle cursor-pointer">
                    <Icon icon="ion:wallet-outline" style="font-size: 30px;color: #fff"/>
                  </div>
                  <h6 class="card-title minh40">موجودی کیف پول</h6>
                  <h5>{{ wallet && wallet.gold ? wallet.gold : 0 }} گرم</h5>
                  <h5>{{ (wallet && wallet.credit ? wallet.credit : 0) |price }} تومان</h5>
                  <div class="text-secondary">نمایش جزئیات</div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-8 data-list-container">
        <div class="con-vs-card minh251">
          <div class="card-header row" style="background: unset;border: 0">
            <div style="background: #e5e5e563;" class="cricle a-cricle">
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-heart">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <h3 style="line-height: 50px; margin-right: 20px;">اطلاعات کاربری</h3>
          </div>
          <div class="card-body statistics-body">
            <div class="row my-spacer">
              <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                <div class="title">نام</div>
                <div class="value">{{ user.fname ? user.fname : "__" }}</div>
              </div>
              <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                <div class="title">نام خانوادگی</div>
                <div class="value">{{ user.lname ? user.lname : "__" }}</div>
              </div>
              <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                <div class="title">شماره موبایل</div>
                <div class="value">{{ user.phone ? user.phone : "__" }}</div>
              </div>
              <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                <div class="title">ایمیل</div>
                <div class="value" style="font-size: 1em">{{ user.email ? user.email : "__" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <modal v-model="walletModel">
      <template v-slot:header>
        تراکنش های کیف پول من
      </template>
      <template v-slot:body>
        <div class="vs-popup--content popup-example">
          <div class="vs-component vs-con-table vs-table-primary">
            <div class="con-tablex vs-table--content">
              <div class="vs-con-tbody vs-table--tbody">

                <!-- start table -->
                <table class="vs-table vs-table--tbody-table">
                  <thead class="vs-table--thead">
                  <tr>
                    <th colspan="1" rowspan="1">
                      شماره ردیف
                    </th>
                    <th colspan="1" rowspan="1">
                      مقدار
                    </th>
                    <th colspan="1" rowspan="1">
                      تاریخ انقضا
                    </th>
                    <th>عملیات</th>
                  </tr>
                  </thead>

                  <!-- loop -->
                  <tr v-for="(item,index) in walletTransactions.rows" :key='index'
                      class="tr-values vs-table--tr tr-table-state-null">
                    <td class="td vs-table--td">
                      <span>
                          {{ item.id }}
                      </span>
                    </td>
                    <td class="td vs-table--td" :class="{'text-danger' : item.value < 0,'text-success' : item.value > 0,}">
                      <span v-if="item.transaction_type == 2">
                          {{ Math.abs(item.value) | priceUnit }}
                      </span>
                      <span v-if="item.transaction_type == 1">
                          {{ Math.abs(item.value) }} گرم
                      </span>
                      <span v-if="item.value > 0"> به کیف پول اضافه شد</span>
                      <span v-else> از کیف پول برداشته شد</span>
                    </td>
                    <td class="td vs-table--td">
                      <span>
                        {{ item.expire_at | jdate | empty}}
                      </span>
                    </td>
                    <td class="center"  data-title='عملیات '>
                      <div @click="showTransactionDetails(item)" class="btn-custom secondary">مشاهده جزئیات</div>
                    </td>
<!--                    <div v-if="walletItemModel && walletItem.id == item.id" class="row overflow-auto">
                      <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                        <div class="title">شماره تراکنش</div>
                        <div class="value">{{ walletItem.id }}</div>
                      </div>
                      <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                        <div class="title">میزان تراکنش</div>
                        <div class="value p-0" :class="{'text-danger' : walletItem.value < 0,'text-success' : walletItem.value > 0,}">
                          <span v-if="walletItem.transaction_type == 2">
                              {{ Math.abs(walletItem.value) | priceUnit }}
                          </span>
                          <span v-if="walletItem.transaction_type == 1">
                              {{ Math.abs(walletItem.value) }} گرم
                          </span>
                          <span v-if="walletItem.value > 0"> به کیف پول اضافه شد</span>
                          <span v-else> از کیف پول برداشته شد</span>
                        </div>
                      </div>
                      <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                        <div class="title">تاریخ انقضا</div>
                        <div class="value">{{ walletItem.expire_at | jdate | empty}}</div>
                      </div>
                      <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                        <div class="title">یادداشت</div>
                        <div class="value">{{ walletItem.note}}</div>
                      </div>
                      <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                        <div class="title">شماره سفارش</div>
                        <div class="value">{{ walletItem.order.id || '-'}}</div>
                      </div>
                      <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                        <div class="title">تاریخ ثبت سفارش</div>
                        <div class="value">{{ walletItem.order.caj || '-'}}</div>
                      </div>
                      <div class="col-sm-6 col-xl-4 mb-2 mb-4">
                        <div class="title">وضعیت سفارش</div>
                        <div class="value">{{ walletItem.order.sts_str || '-'}}</div>
                      </div>
                    </div>-->
                  </tr>
                  <!-- loop -->

                </table>
                <!-- end table -->
                <pagination
                    v-model="pagination.page"
                    :total-pages="Math.ceil(walletTransactions.count/pagination.limit)"
                    @pagechanged="getWalletTransactions"/>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal>
    <modal v-model="walletItemModel">
      <template #header>
        جزئیات تراکنش
        {{walletItem.id}}
      </template>
      <template #body>
        <div class="row overflow-auto">
          <div class="col-sm-6 col-xl-4 mb-2 mb-4">
            <div class="title">شماره تراکنش</div>
            <div class="value">{{ walletItem.id }}</div>
          </div>
          <div class="col-sm-6 col-xl-4 mb-2 mb-4">
            <div class="title">میزان تراکنش</div>
            <div class="value p-0" :class="{'text-danger' : walletItem.value < 0,'text-success' : walletItem.value > 0,}">
              <span v-if="walletItem.transaction_type == 2">
                  {{ Math.abs(walletItem.value) | priceUnit }}
              </span>
              <span v-if="walletItem.transaction_type == 1">
                  {{ Math.abs(walletItem.value) }} گرم
              </span>
              <span v-if="walletItem.value > 0"> به کیف پول اضافه شد</span>
              <span v-else> از کیف پول برداشته شد</span>
            </div>
          </div>
          <div class="col-sm-6 col-xl-4 mb-2 mb-4">
            <div class="title">تاریخ انقضا</div>
            <div class="value">{{ walletItem.expire_at | jdate | empty}}</div>
          </div>
          <div class="col-sm-6 col-xl-4 mb-2 mb-4">
            <div class="title">یادداشت</div>
            <div class="value">{{ walletItem.note}}</div>
          </div>
          <div class="col-sm-6 col-xl-4 mb-2 mb-4">
            <div class="title">شماره سفارش</div>
            <div class="value">{{ walletItem.order.id || '-'}}</div>
          </div>
          <div class="col-sm-6 col-xl-4 mb-2 mb-4">
            <div class="title">تاریخ ثبت سفارش</div>
            <div class="value">{{ walletItem.order.caj || '-'}}</div>
          </div>
          <div class="col-sm-6 col-xl-4 mb-2 mb-4">
            <div class="title">وضعیت سفارش</div>
            <div class="value">{{ walletItem.order.sts_str || '-'}}</div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import axios from "@/plugins/axios"
import modal from "@/components/modal";
import pagination from "@/components/Pagination";
import {Icon} from "@iconify/vue2"

export default {
  props: {
    togglePreLoader: Function
  },
  components: {
    Icon,
    modal,
    pagination
  },
  data() {
    return {
      flag: false,
      walletModel: false,
      data: undefined,
      user: {},
      wallet: undefined,
      pagination: {page: 1, limit: 10},
      walletTransactions: {rows: [], count: 0},
      walletItem: {},
      walletItemModel: false,
    }
  },
  methods: {
    async getWallet() {
      try {
        this.togglePreLoader('open')
        let {data} = await axios.get("/cu/customer/wallet")
        this.wallet = data
      } catch (error) {
        if (error.response && error.response.data.errors) {
          let str_error = ''
          for (let item of Object.values(error.response.data.errors)) {
            item.map(xx => {
              if (xx.includes("shipping address")) {
                str_error += xx.replace("shipping address", "آدرس") + "<br/>"
              } else {
                str_error += xx + "<br/>"
              }
            })
          }
          this.$vs.notify({
            title: 'خطایی رخ داد',
            time: 3500,
            text: str_error,
            color: 'var(--secondary-color)',
            icon: 'error_outline'
          })
        } else {
          if (error) {
            if (error == "Error: Network Error") {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: "اتصال برقرار نشد",
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            } else {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: error,
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            }
          }
        }
      } finally {
        this.togglePreLoader('close')
      }
    },
    async getDashboardData() {
      try {
        this.togglePreLoader('open')
        let {data} = await axios.get("cu/order/report")
        this.data = data
        this.flag = true
      } catch (error) {
        if (error.response && error.response.data.errors) {
          let str_error = ''
          for (let item of Object.values(error.response.data.errors)) {
            item.map(xx => {
              if (xx.includes("shipping address")) {
                str_error += xx.replace("shipping address", "آدرس") + "<br/>"
              } else {
                str_error += xx + "<br/>"
              }
            })
          }
          this.$vs.notify({
            title: 'خطایی رخ داد',
            time: 3500,
            text: str_error,
            color: 'var(--secondary-color)',
            icon: 'error_outline'
          })
        } else {
          if (error) {
            if (error == "Error: Network Error") {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: "اتصال برقرار نشد",
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            } else {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: error,
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            }
          }
        }
      } finally {
        this.togglePreLoader('close')
      }
    },
    async getWalletTransactions() {
      try {
        this.togglePreLoader('open')
        let {data} = await axios.post("/cu/customer/wallet/transaction", {page: this.pagination.page-1, limit: this.pagination.limit})
        this.walletTransactions = data
      } catch (error) {
        if (error.response && error.response.data.errors) {
          let str_error = ''
          for (let item of Object.values(error.response.data.errors)) {
            item.map(xx => {
              if (xx.includes("shipping address")) {
                str_error += xx.replace("shipping address", "آدرس") + "<br/>"
              } else {
                str_error += xx + "<br/>"
              }
            })
          }
          this.$vs.notify({
            title: 'خطایی رخ داد',
            time: 3500,
            text: str_error,
            color: 'var(--secondary-color)',
            icon: 'error_outline'
          })
        } else {
          if (error) {
            if (error == "Error: Network Error") {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: "اتصال برقرار نشد",
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            } else {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: error,
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            }
          }
        }
      } finally {
        this.togglePreLoader('close')
      }
    },
    showTransactionDetails(item){
      this.walletItem = item
      this.walletItemModel = !this.walletItemModel
    }
  },
  async created() {
    await this.getWallet()
    await this.getWalletTransactions()
    await this.getDashboardData()
    this.user = JSON.parse(localStorage.getItem("userInfo")) || JSON.parse(localStorage.userInfo)

  }
}
</script>

<style lang="css" scoped>
#ecommerce-checkout-demo .item-view-primary-action-btn {
  color: #2c2c2c !important;
  background-color: #f6f6f6;
}

#ecommerce-checkout-demo .item-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
}

#ecommerce-checkout-demo .vue-form-wizard::v-deep .wizard-header {
  padding: 0;
}

#ecommerce-checkout-demo ::v-deep .wizard-tab-content {
  padding-right: 0;
  padding-left: 0;
}

.fit {
  width: fit-content !important;
}

.minh40 {
  min-height: 40px;
}

.minh251 {
  min-height: 251px;
}

.same-height .col-lg-6 {
  height: 100%;
}

.con-vs-card {
  margin-bottom: 30px;
}
</style>